var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublicReccoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72571 2.28983C5.16881 3.21597 2.46801 6.26324 2.05493 10H6.05009C6.2743 7.23681 7.1991 4.58442 8.72571 2.28983ZM13.2743 2.28983C14.8009 4.58442 15.7257 7.23681 15.9499 10H19.9451C19.532 6.26324 16.8312 3.21597 13.2743 2.28983ZM13.9424 10C13.6912 7.28683 12.6697 4.70193 11 2.5508C9.33032 4.70193 8.30879 7.28683 8.05759 10H13.9424ZM8.05759 12H13.9424C13.6912 14.7132 12.6697 17.2981 11 19.4492C9.33032 17.2981 8.30879 14.7132 8.05759 12ZM6.05009 12H2.05493C2.46801 15.7368 5.16881 18.784 8.72571 19.7102C7.1991 17.4156 6.2743 14.7632 6.05009 12ZM13.2743 19.7102C14.8009 17.4156 15.7257 14.7632 15.9499 12H19.9451C19.532 15.7368 16.8312 18.784 13.2743 19.7102ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "url(#paint0_linear_11822_121762)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11822_121762",
    x1: 11,
    y1: 0,
    x2: 11,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6073EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC31C2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicReccoIcon);
export default __webpack_public_path__ + "static/media/public-recco-icon.e687b052b89d22644f8afe9e1ea0c1bf.svg";
export { ForwardRef as ReactComponent };